import React, { useEffect, useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';


const MultiSelectDropdown = ({
  categoryData = [],
  selectedCategories,
  setSelectedCategories,
  placeholder = "Select...",
  noOptionsMessage = "No options",
  setCurrentPage,
  fetchOptionsApi,
  setCurrentPinkSectionPage
}) => {

  const [allOptions, setAllOptions] = useState([]);
  const [defaultOptions, setDefaultOptions] = useState([]);
  useEffect(() => {
    if (Array.isArray(categoryData)) {
      const formatted = categoryData.map((item) => ({
        value: item.group_id || item.id || item.product_ids || item,
        label: item.name || item.name_en || item.group_name || item,
        name_tc: item.name_tc || '',
        code: item.code
      }));
      setAllOptions(formatted);
      setDefaultOptions((prev) => {
        // Merge only new options from categoryData
        const newOptions = formatted.filter(f => !prev.some(p => p.value === f.value));
        return [...prev, ...newOptions];
      });
    }
  }, [categoryData]);

  const getSelectedValues = () => {
    const combinedOptions = [...allOptions, ...defaultOptions];
    const seen = new Set();
    const uniqueCombined = combinedOptions.filter((opt) => {
      if (!seen.has(opt.value)) {
        seen.add(opt.value);
        return true;
      }
      return false;
    });

    return selectedCategories
      .map((id) => uniqueCombined.find((opt) => opt.value === id))
      .filter(Boolean);
  };

  const handleChange = (newValue) => {
    const selectedIds = newValue.map((opt) => opt.value);
    setSelectedCategories(selectedIds);
    if (setCurrentPage) setCurrentPage(1);
    if (setCurrentPinkSectionPage) setCurrentPinkSectionPage(1);


  };

  const loadOptions = async (search, loadedOptions, { page }) => {
    try {
      const response = await fetchOptionsApi('', search, page);
      const { options, hasMore } = response;

      // Store for initial selected value rendering
      if (page === 1) {
        setDefaultOptions(options);
      }
      return {
        options,
        hasMore,
        additional: {
          page: page + 1
        }
      };
    } catch (error) {
      console.error("Error loading options", error);
      return {
        options: [],
        hasMore: false
      };
    }
  };

  return (
    <div className="multi-select-container" style={{ width: '100%', maxWidth: '400px' }}>
      <AsyncPaginate
        isMulti
        defaultOptions={true}
        value={getSelectedValues()}
        loadOptions={loadOptions}
        onChange={handleChange}
        placeholder={placeholder}
        closeMenuOnSelect={false}
        additional={{ page: 1 }}
        noOptionsMessage={() => noOptionsMessage}
        className="custom-multiselect"
        classNamePrefix="my-select"
      // searchable={true}
      />
    </div>
  );
};
export const DependentMultiSelectDropdown = ({
  selectedValues,
  setSelectedValues,
  placeholder = "Select...",
  noOptionsMessage = "No options",
  setCurrentPage,
  fetchOptionsApi,
  setCurrentPinkSectionPage = () => { },
  dependentFilters = {},
}) => {
  const [reloadToken, setReloadToken] = useState(0);
  const [allOptions, setAllOptions] = useState([]);
  const filtersKey = JSON.stringify(dependentFilters);

  // 🔄 Refresh whenever filters change
  useEffect(() => {
    const timer = setTimeout(() => {
      setReloadToken((prev) => prev + 1);
      setAllOptions((prev) => {
        // Ensure currently selected IDs are included
        const selectedOptions = selectedValues
          .map((id) => prev.find((o) => o.value === id))
          .filter(Boolean);
        return selectedOptions;
      });
    }, 1000); // debounce filter changes by 1s

    return () => clearTimeout(timer);
  }, [filtersKey, selectedValues]); // ✅ triggers when any filter changes (debounced)

  const handleChange = (newValue) => {
    const selectedIds = newValue.map((opt) => opt.value);
    setSelectedValues(selectedIds, newValue);
    if (setCurrentPage) setCurrentPage(1);
    if (setCurrentPinkSectionPage) setCurrentPinkSectionPage(1);
  };

  const loadOptions = async (search, loadedOptions, { page }) => {
    try {
      const response = await fetchOptionsApi("", search, page, dependentFilters);
      const { options, hasMore } = response;

      // Merge fetched options into allOptions for selected value rendering
      setAllOptions((prev) => {
        const seen = new Set(prev.map((o) => o.value));
        const newOptions = options.filter((o) => !seen.has(o.value));
        return [...prev, ...newOptions];
      });

      return {
        options,
        hasMore,
        additional: { page: page + 1, reloadToken }, // pass reloadToken
      };
    } catch (error) {
      console.error("Error loading options", error);
      return { options: [], hasMore: false, additional: { page: page + 1, reloadToken } };
    }
  };

  // Map selected IDs → option objects
  const getSelectedValues = () =>
    selectedValues
      .map((id) => allOptions.find((opt) => opt.value === id))
      .filter(Boolean);

  return (
    <div className="multi-select-container" style={{ width: "100%", maxWidth: "400px" }}>
      <AsyncPaginate
        key={reloadToken} // ✅ forces remount on dependent filter change
        isMulti
        defaultOptions
        value={getSelectedValues()}
        loadOptions={loadOptions}
        onChange={handleChange}
        placeholder={placeholder}
        closeMenuOnSelect={false}
        additional={{ page: 1, reloadToken }}
        noOptionsMessage={() => noOptionsMessage}
        className="custom-multiselect"
        classNamePrefix="my-select"
      />
    </div>
  );
};


export default MultiSelectDropdown;
